import React from "react";
import { withTranslation } from "react-i18next";
import MarketDeliveryRangesClient from "../../../../shared/clients/MarketDeliveryRangesClient";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import dealerStyles from "../dealer/DealerDeliveryRanges.module.scss";
import nscStyles from "../nsc/NscDeliveryRanges.module.scss";
import Grid from "@material-ui/core/Grid";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import EditIcon from "../../../../shared/Edit/EditIcon";
import OptionToggle from "../dealer/OptionToggle";
import DeliveryRangeHeader from "../dealer/DeliveryRangeHeader";
import { Button } from "@material-ui/core";
import { PricesApplied } from "../../../../shared/feedback/PricesApplied";
import ValidationRules from "../../../../common/ValidationRules";
import MarketDeliveryRangesRow from "./MarketDeliveryRangesRow";
import UpperCaseText from "../../../../utils/UpperCaseText";

class MarketDeliveryRanges extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryData: {},
      isEditActive: false,
      dataLoaded: false,
      saveSuccess: false,
      firstDeclined: 10,
      firstLoad: false,
    };
    this.saveRanges = this.saveRanges.bind(this);
    this.handleTextOnChange = this.handleTextOnChange.bind(this);
    this.distanceUnit =
      this.props.localizedInfo && this.props.localizedInfo.defaultDistanceUnit
        ? this.props.localizedInfo.defaultDistanceUnit
        : "NA";
    this.currencySymbol =
      this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
        ? this.props.localizedInfo.defaultCurrency.symbol
        : "NA";
  }

  componentDidMount() {
    ValidatorForm.addValidationRule("checkingRows", (fromVal, currentRow) => {
      let isValid = true;
      if (
        currentRow < 1 ||
        this.state.deliveryData.deliveryRangeOptions[currentRow - 1].to === null
      ) {
        isValid = true;
      } else if (
        this.state.deliveryData.deliveryRangeOptions[currentRow - 1].to ===
          "" ||
        isNaN(
          this.state.deliveryData.deliveryRangeOptions[currentRow - 1].to
        ) ||
        fromVal === ""
      ) {
        isValid = true;
      } else if (
        parseInt(fromVal) !==
        parseInt(
          this.state.deliveryData.deliveryRangeOptions[currentRow - 1].to
        ) +
          1
      ) {
        isValid = false;
      }

      return isValid;
    });

    /**
     * Checking the input value is zero or noe
     * Validation Fails - if the input value has other than 0-9
     */
    ValidatorForm.addValidationRule("shouldBeZero", (value, index) => {
      // eslint-disable-next-line
      if (index != 0) return true;
      const re = /^[0\b]+$/;
      let isValid = true;
      if (value !== "" && !re.test(value)) {
        isValid = false;
      }
      return isValid;
    });
    ValidationRules();
    this.fetchMarketDeliveryRanges();
  }

  handleTextOnChange(event) {
    const deliveryDataCopy = JSON.parse(
      JSON.stringify(this.state.deliveryData)
    );

    const value = event.target.value;
    const rowId = event.target.id;
    if (event.target.name === "rangeFrom" + rowId) {
      deliveryDataCopy.deliveryRangeOptions[rowId].from = value;
    } else if (event.target.name === "rangeTo" + rowId) {
      const nextRow = parseInt(rowId) + 1;
      deliveryDataCopy.deliveryRangeOptions[rowId].to = value;
      if (
        Number(value) &&
        nextRow !== deliveryDataCopy.deliveryRangeOptions.length
      ) {
        // Auto increment next row
        deliveryDataCopy.deliveryRangeOptions[nextRow].from =
          parseInt(value) + 1;
      }
    } else if (event.target.name === "rangeValue" + rowId) {
      deliveryDataCopy.deliveryRangeOptions[rowId].value = value;
    }

    this.setState({ deliveryData: deliveryDataCopy });
  }

  handleChargeChange = (e, charge) => {
    const rangesCopy = JSON.parse(JSON.stringify(this.state.deliveryData));
    rangesCopy[charge] = e.target.value;
    this.setState({ deliveryData: rangesCopy });
  };

  enableButton() {
    if (this.state.saveSuccess) this.setState({ saveSuccess: false });
  }

  deleteRow = () => {
    const rangesCopy = JSON.parse(JSON.stringify(this.state.deliveryData));
    rangesCopy.deliveryRangeOptions.pop();
    this.setState({ deliveryData: rangesCopy });
  };

  addRow = () => {
    const rangesCopy = JSON.parse(JSON.stringify(this.state.deliveryData));
    const prevRow = rangesCopy.deliveryRangeOptions.length - 1;
    const previousEnabled = rangesCopy.deliveryRangeOptions[prevRow].enabled;
    rangesCopy.deliveryRangeOptions.push({
      from: "",
      to: "",
      value: "",
      enabled: previousEnabled,
    });
    this.setState({ deliveryData: rangesCopy });
  };

  fetchMarketDeliveryRanges() {
    MarketDeliveryRangesClient.getMarketDeliveryRanges(this.props.user).then(
      (response) => {
        if (response.deliveryRangeOptions !== null) {
          let firstDeclined = response.deliveryRangeOptions.indexOf(
            response.deliveryRangeOptions.find((option) => !option.enabled)
          );
          if (firstDeclined === -1) {
            firstDeclined = 10;
          }

          // If last band ends as null, display "over"
          const prevRow = response.deliveryRangeOptions.length - 1;
          if (response.deliveryRangeOptions[prevRow].to === null) {
            response.deliveryRangeOptions[prevRow].to = "OVER";
          }
          this.setState({
            deliveryData: response,
            dataLoaded: true,
            firstDeclined,
          });
        } else {
          response.deliveryRangeOptions = [
            { from: "0", to: "", enabled: true, value: "" },
            { from: "", to: "", enabled: true, value: "" },
          ];
          this.setState({
            deliveryData: response,
            dataLoaded: true,
            isEditActive: true,
            firstLoad: true,
          });
        }
      }
    );
  }

  saveRanges() {
    this.props.hideOrShow(true);
    if (!this.state.deliveryData.deliveryEnabled) {
      if (!this.state.firstLoad) {
        // No need to update on first load - default is already false
        MarketDeliveryRangesClient.disableRanges(this.props.user)
          .then(() => {
            this.setState({ saveSuccess: true, isEditActive: false });
          })
          .finally(() => {
            this.props.hideOrShow(false);
          });
      } else {
        this.setState({ saveSuccess: true });
        this.props.hideOrShow(false);
      }
    } else {
      const parsedRanges = this.parseRanges();
      MarketDeliveryRangesClient.saveMarketDeliveryRanges(
        parsedRanges,
        this.props.user
      )
        .then(() => {
          this.setState({
            saveSuccess: true,
            isEditActive: false,
            firstLoad: false,
          });
        })
        .finally(() => {
          this.props.hideOrShow(false);
        });
    }
  }

  parseRanges() {
    const ranges = JSON.parse(JSON.stringify(this.state.deliveryData));
    ranges.deliveryRangeOptions.forEach((range) => {
      if (!Number(range.to) && UpperCaseText(range.to) === "OVER") {
        range.to = null;
      }
    });
    return ranges;
  }

  toggleRangeRow = (e, rowNo) => {
    const rangesCopy = JSON.parse(JSON.stringify(this.state.deliveryData));
    const checked = e.target.checked;
    rangesCopy.deliveryRangeOptions[rowNo].enabled = checked;
    const nextRow = parseInt(rowNo) + 1;
    let firstDeclined = this.state.firstDeclined;
    if (!checked) {
      for (let i = nextRow; i < rangesCopy.deliveryRangeOptions.length; ++i) {
        rangesCopy.deliveryRangeOptions[i].enabled = false;
      }
      if (rowNo < firstDeclined) {
        firstDeclined = rowNo;
      }
    } else {
      firstDeclined = firstDeclined + 1;
    }
    this.setState({ deliveryData: rangesCopy, firstDeclined });
  };

  updateToggle = (e, toggleName) => {
    const rangesCopy = JSON.parse(JSON.stringify(this.state.deliveryData));
    const checked = e.target.checked;
    rangesCopy[toggleName] = checked;
    if (toggleName === "sellInternational" && !e.target.checked) {
      rangesCopy["deliverInternational"] = false;
    }
    this.setState({ deliveryData: rangesCopy }, () => {
      // On first load, put cursor in first field
      if (checked && toggleName === "deliveryEnabled" && this.state.firstLoad) {
        document.getElementsByName("rangeTo0")[0].focus();
      }
    });
    this.enableButton();
  };

  editOnClick = () => {
    this.setState((prevState) => ({
      isEditActive: !prevState.isEditActive,
    }));
    this.enableButton();
  };

  render() {
    return (
      this.state.dataLoaded && (
        <div>
          <DeliveryRangeHeader
            {...this.props}
            header={this.props.t("nscDeliveryBands.subheader")}
          />

          <ValidatorForm onSubmit={this.saveRanges}>
            <OptionToggle
              {...this.props}
              id="enableDelivery"
              header={this.props.t("nscDeliveryBands.authorizeDelivery")}
              toggleName="deliveryEnabled"
              data={this.state.deliveryData["deliveryEnabled"]}
              action={(e) => this.updateToggle(e, "deliveryEnabled")}
            />
            <br />
            {this.state.deliveryData.deliveryEnabled && (
              <>
                <div
                  className={dealerStyles.tableHeader}
                  data-testid="rangeTable"
                >
                  <Grid
                    id="deliveryRangeTableHeader"
                    container
                    className="pagePaddingLeft pagePaddingRight"
                  >
                    <Grid item md={5}>
                      <div className={dealerStyles.headerWrap}>
                        <span>
                          {`${this.props.t("dealerDeliveryBands.distance")} (${
                            this.distanceUnit
                          }) `}
                        </span>
                      </div>
                    </Grid>
                    <Grid item md={3}>
                      <div className={dealerStyles.headerWrap}>
                        {this.props.t("dealerDeliveryBands.delivery")}
                      </div>
                    </Grid>
                    <Grid
                      item
                      md={4}
                      className={`${dealerStyles.rowHeader} ${dealerStyles.right}`}
                    >
                      <HasPermissionTo
                        perform={["deliveryRanges:write"]}
                        permissions={
                          this.props.user.permissions.rolePermissions
                        }
                        render={() => {
                          return (
                            <div
                              className={dealerStyles.headerWrap}
                              data-testid="editCharge"
                            >
                              {this.props.t(
                                "dealerDeliveryBands.deliveryCharge"
                              )}
                              <EditIcon onClick={this.editOnClick} />
                            </div>
                          );
                        }}
                        noRender={() => {
                          return (
                            <div className={dealerStyles.headerWrap}>
                              {this.props.t(
                                "dealerDeliveryBands.deliveryCharge"
                              )}
                            </div>
                          );
                        }}
                      />
                    </Grid>
                  </Grid>
                </div>

                {this.state.deliveryData.deliveryRangeOptions &&
                  this.state.deliveryData.deliveryRangeOptions.map(
                    (item, index) => {
                      return (
                        <MarketDeliveryRangesRow
                          key={index}
                          editMode={this.state.isEditActive}
                          currentRow={index}
                          dataObjItem={item}
                          currency={this.currencySymbol}
                          action={this.handleTextOnChange}
                          currentNoOfRows={
                            this.state.deliveryData.deliveryRangeOptions.length
                          }
                          firstDeclined={this.state.firstDeclined}
                          toggleRangeRow={this.toggleRangeRow}
                          deleteAction={this.deleteRow}
                        />
                      );
                    }
                  )}

                {this.state.isEditActive && (
                  <div>
                    {this.state.deliveryData.deliveryRangeOptions.length ===
                    5 ? (
                      <p className={nscStyles.max}>
                        {this.props.t("nscDeliveryBands.maxRows")}
                      </p>
                    ) : (
                      <Button
                        id="addDeliveryRangeBtn"
                        className={nscStyles.add}
                        onClick={this.addRow}
                        component="button"
                      >
                        {this.props.t("nscDeliveryBands.add")}
                      </Button>
                    )}
                  </div>
                )}

                <OptionToggle
                  {...this.props}
                  id="doUDeliverHeader"
                  header={this.props.t("dealerDeliveryBands.doUDeliverHeader")}
                  body={this.props.t("dealerDeliveryBands.doUDeliverBody")}
                  toggleName="nonMainlandDelivery"
                  data={this.state.deliveryData["nonMainlandDelivery"]}
                  action={(e) => this.updateToggle(e, "nonMainlandDelivery")}
                />
                <div
                  className={`${dealerStyles.subSectionPriceBackGround} pagePaddingLeft pagePaddingRight`}
                >
                  <span className={dealerStyles.headerWrap}>
                    {`${this.props.t(
                      "dealerDeliveryBands.delveryChargeNational"
                    )} (${this.currencySymbol})`}
                    &nbsp;
                  </span>

                  {this.state.isEditActive ? (
                    <TextValidator
                      style={{ borderRadius: "0px" }}
                      name="nonMainlandDelivery"
                      variant="outlined"
                      value={
                        this.state.deliveryData.nonMainlandDeliveryCharge ===
                        null
                          ? ""
                          : this.state.deliveryData.nonMainlandDeliveryCharge
                      }
                      onChange={(e) =>
                        this.handleChargeChange(e, "nonMainlandDeliveryCharge")
                      }
                      validators={[
                        "required",
                        "minNumber:0",
                        "isNumber",
                        "isNumericWithTwoDecimalPlaces",
                      ]}
                      errorMessages={[
                        this.props.t("nscDeliveryBands.required"),
                        this.props.t("nscDeliveryBands.invalid"),
                        this.props.t("nscDeliveryBands.invalid"),
                        this.props.t("nscDeliveryBands.invalid"),
                      ]}
                    />
                  ) : (
                    <p>{this.state.deliveryData.nonMainlandDeliveryCharge}</p>
                  )}
                </div>

                <OptionToggle
                  {...this.props}
                  id="doUSellHeader"
                  header={this.props.t("dealerDeliveryBands.doUSellHeader")}
                  body={this.props.t("dealerDeliveryBands.doUSellBody")}
                  toggleName="sellInternational"
                  data={this.state.deliveryData["sellInternational"]}
                  action={(e) => this.updateToggle(e, "sellInternational")}
                />

                <OptionToggle
                  {...this.props}
                  id="doUDeliverInterHeader"
                  header={this.props.t(
                    "dealerDeliveryBands.doUDeliverInHeader"
                  )}
                  body={this.props.t("dealerDeliveryBands.doUDeliverInBody")}
                  toggleName="deliverInternational"
                  data={this.state.deliveryData["deliverInternational"]}
                  action={(e) => this.updateToggle(e, "deliverInternational")}
                />

                <div
                  className={`${dealerStyles.subSectionPriceBackGround} pagePaddingLeft pagePaddingRight`}
                >
                  <span className={dealerStyles.headerWrap}>
                    {`${this.props.t(
                      "dealerDeliveryBands.delveryChargeInterNational"
                    )} (${this.currencySymbol})`}
                    &nbsp;
                  </span>

                  {this.state.isEditActive ? (
                    <TextValidator
                      style={{ borderRadius: "0px" }}
                      name="deliverInternationalText"
                      variant="outlined"
                      value={
                        this.state.deliveryData.deliverInternationalCharge ===
                        null
                          ? ""
                          : this.state.deliveryData.deliverInternationalCharge
                      }
                      onChange={(e) =>
                        this.handleChargeChange(e, "deliverInternationalCharge")
                      }
                      validators={[
                        "required",
                        "minNumber:0",
                        "isNumber",
                        "isNumericWithTwoDecimalPlaces",
                      ]}
                      errorMessages={[
                        this.props.t("nscDeliveryBands.required"),
                        this.props.t("nscDeliveryBands.invalid"),
                        this.props.t("nscDeliveryBands.invalid"),
                        this.props.t("nscDeliveryBands.invalid"),
                      ]}
                    />
                  ) : (
                    <p>{this.state.deliveryData.deliverInternationalCharge}</p>
                  )}
                </div>
              </>
            )}

            <div className={dealerStyles.actionSection}>
              <HasPermissionTo
                perform={["deliveryRanges:write"]}
                permissions={this.props.user.permissions.rolePermissions}
                condition={!this.state.saveSuccess}
                render={() => {
                  return (
                    <Button
                      type="submit"
                      id="savePricing"
                      data-testid="saveBands"
                      component="button"
                      className={dealerStyles.saveBtn}
                    >
                      {this.props.t("dealerDeliveryBands.save")}
                    </Button>
                  );
                }}
              />
              {this.state.saveSuccess && (
                <PricesApplied
                  success={true}
                  text={this.props.t("dealerDeliveryBands.pricesApplied")}
                />
              )}
            </div>
          </ValidatorForm>
        </div>
      )
    );
  }
}

export default withTranslation("emp")(MarketDeliveryRanges);
